import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-records-counter',
  templateUrl: './records-counter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecordsCounterComponent {
  @Input() numberOfRecords: number;
}
